export default __webpack_public_path__ + "static/media/hero-image.376898e4.png";